export type Point = {
  x: number;
  y: number;
};

export const subtract = (a: Point, b: Point): Point => {
  return {
    x: a.x - b.x,
    y: a.y - b.y,
  };
};

export default function getFocusPreviewCoords(
  target: HTMLElement | SVGElement,
  options: any
) {
  if (!target || target === null || target === undefined) {
    return { x: 0, y: 0 };
  }

  const bb = target.getBoundingClientRect();
  const middle = { x: bb.width / 2, y: bb.height / 2 };
  let res = subtract(bb, middle);

  if (options) {
    res.x -= options.offsetX;
    res.y -= options.offsetY;
    console.log(res);
  }

  return res;
}
